import { LINK_LEVEL_SETTINGS } from './accessResource';
import { ACCESS_FEATURE } from './accessFeatures';
import type { AccessResource } from '../../types';

export const ACCESS_FEATURE_RESOURCE: Record<string, AccessResource> = {
  [ACCESS_FEATURE.TEMPLATE_ONLY]: LINK_LEVEL_SETTINGS,
};
